import React, { useContext } from 'react'
import { EntryAndDepartureList } from './EntryAndDepartureList'
import { CustomTable } from '../../CustomTable/CustomTable';
import { t } from 'i18next';
import EntryAndDepartureReportContext from '../../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { Spinner } from 'reactstrap';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';

export const EntryAndDepartureTable = ({ setShowDetailModal, setResourceInfo }) => {

    const { entryAndDepartureReportState, setTableHeaders, getEntriesAndDepartures } = useContext(EntryAndDepartureReportContext);
    const { tableHeaders, isFetching, entriesAndDeparturesPaginated, filters } = entryAndDepartureReportState;

    const formatedHeaders = tableHeaders.map(header => ({
        ...header,
        key: t(header.key)
    }));

    const handleSort = (key) => {
        const newData = tableHeaders.map((header) => (
            header.columnOrder === key
                ? { ...header, active: !header.active, order: header.order === 'ASC' ? 'DESC' : 'ASC' }
                : { ...header, active: false, order: 'DESC' }
        ));

        const activeHeader = newData.find((header) => header.columnOrder === key)

        setTableHeaders(newData);
        getEntriesAndDepartures({
            ...filters,
            'column_order': activeHeader.columnOrder,
            'order_type': activeHeader.order,
            'reg_from': 1
        })
    }

    return (
        <>

            {isFetching ?
                <div className='mt-3 d-flex justify-content-center align-items-center'>
                    <Spinner />
                </div> : null}


            {entriesAndDeparturesPaginated.length > 0 ?

                <CustomTable headers={formatedHeaders} onClickSort={handleSort} id={'entryAndDepartureReportTable'}>

                    {
                        entriesAndDeparturesPaginated.map((item, i) => {
                            return (
                                <EntryAndDepartureList
                                    key={i}
                                    data={item}
                                    setShowDetailModal={setShowDetailModal}
                                    setResourceInfo={setResourceInfo}
                                />
                            )
                        })
                    }

                </CustomTable>
                :
                <div className='mt-3 d-flex justify-content-center align-items-center'>
                    <EmptyStateOne message={t('NO_DATA')} />
                </div>
            }

        </>
    )
}
